import React, { useEffect, useState } from "react";
import { isServiceStatusEnabled, runStartupHealthChecks } from "../lib/healthCheck";
import "./ServiceStatusBanner.css";

const ServiceStatusBanner = ({ appLabel = "App" }) => {
  const enabled = isServiceStatusEnabled();
  const [loading, setLoading] = useState(enabled);
  const [checks, setChecks] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    let alive = true;

    runStartupHealthChecks().then((result) => {
      if (!alive) return;
      setChecks(result);
      setLoading(false);
      console.group(`[${appLabel}] Startup service check`);
      console.log("Firebase:", result.firebase.ok ? "OK" : "FAIL", result.firebase.message);
      console.log("Cloudinary:", result.cloudinary.ok ? "OK" : "FAIL", result.cloudinary.message);
      console.groupEnd();
    });

    return () => {
      alive = false;
    };
  }, [appLabel, enabled]);

  if (!enabled || dismissed) return null;

  if (loading) {
    return (
      <div className="svc-status svc-status--loading" role="status" aria-live="polite">
        <span className="svc-status__spinner" aria-hidden="true" />
        Checking Firebase and Cloudinary…
      </div>
    );
  }

  const tone = checks.allOk ? "ok" : "error";

  return (
    <div className={`svc-status svc-status--${tone}`} role="status" aria-live="polite">
      <div className="svc-status__body">
        <strong>{appLabel}</strong>
        <ul className="svc-status__list">
          <li className={checks.firebase.ok ? "is-ok" : "is-bad"}>
            <span>Firebase</span>
            <span>{checks.firebase.message}</span>
          </li>
          <li className={checks.cloudinary.ok ? "is-ok" : "is-bad"}>
            <span>Cloudinary</span>
            <span>{checks.cloudinary.message}</span>
          </li>
        </ul>
      </div>
      <button
        type="button"
        className="svc-status__close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss service status"
      >
        ×
      </button>
    </div>
  );
};

export default ServiceStatusBanner;
